export default "__VITE_ASSET__bf609c11__"